import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component StopwatchIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <StopwatchIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <StopwatchIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StopwatchIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      data-testid="StopwatchIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M8 1.333a6.667 6.667 0 1 1 0 13.333A6.667 6.667 0 0 1 8 1.333m0 1.334a5.333 5.333 0 1 0 0 10.666A5.333 5.333 0 0 0 8 2.667M8.666 4v4.667H7.333V4zm4.39-3.886 2.83 2.829-.943.942-2.829-2.828.943-.943Z"
        clipRule="evenodd"
      />
    </svg>
  )
);
StopwatchIcon.displayName = "StopwatchIcon";
export default StopwatchIcon;
